<script setup>
import { computed } from 'vue'

const props = defineProps({
	modelValue: { type: Number, default: 1 },
	totalPages: { type: Number, default: 1 },
})

const emit = defineEmits(['update:modelValue'])

// Build a page list with ellipsis: 1 2 3 … N
const pageItems = computed(() => {
	const total = props.totalPages
	const current = props.modelValue
	if (total <= 1) return [1]
	const delta = 1
	const range = []
	for (let i = 1; i <= total; i++) {
		if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
			range.push(i)
		}
	}
	const withDots = []
	let prev
	for (const i of range) {
		if (prev) {
			if (i - prev === 2) withDots.push(prev + 1)
			else if (i - prev > 2) withDots.push('...')
		}
		withDots.push(i)
		prev = i
	}
	return withDots
})

const goToPage = (p) => {
	if (typeof p !== 'number') return
	if (p < 1 || p > props.totalPages || p === props.modelValue) return
	emit('update:modelValue', p)
}
const nextPage = () => {
	if (props.modelValue < props.totalPages) emit('update:modelValue', props.modelValue + 1)
}
const lastPage = () => {
	if (props.modelValue < props.totalPages) emit('update:modelValue', props.totalPages)
}
</script>

<template>
	<div v-if="totalPages > 1" class="flex items-center justify-start gap-1 mt-4">
		<template v-for="(item, idx) in pageItems" :key="idx">
			<button
				v-if="typeof item === 'number'"
				type="button"
				class="h-7 min-w-[28px] px-2 inline-flex items-center justify-center rounded-md text-tiny transition-colors"
				:class="
					item === modelValue
						? 'bg-surface-3 text-white'
						: 'text-surface-7 hover:text-white hover:bg-surface-3'
				"
				@click="goToPage(item)"
			>
				{{ item }}
			</button>
			<span v-else class="h-7 px-1 inline-flex items-center justify-center text-tiny text-surface-7">
				…
			</span>
		</template>
		<button
			type="button"
			class="h-7 min-w-[28px] px-2 inline-flex items-center justify-center rounded-md text-tiny text-surface-7 hover:text-white hover:bg-surface-3 disabled:opacity-40"
			:disabled="modelValue >= totalPages"
			title="Next page"
			@click="nextPage"
		>
			&gt;
		</button>
		<button
			type="button"
			class="h-7 min-w-[28px] px-2 inline-flex items-center justify-center rounded-md text-tiny text-surface-7 hover:text-white hover:bg-surface-3 disabled:opacity-40"
			:disabled="modelValue >= totalPages"
			title="Last page"
			@click="lastPage"
		>
			&gt;&gt;
		</button>
	</div>
</template>

<style scoped></style>
